// extracted by css-extract-rspack-plugin
export default {"handle_btn":"handle_btn___iv4eR","table_icon":"table_icon___KBw7v"};